import { Select, SelectProps } from '@shared/Form/Select'
import { useGetSessionTree } from '@services/session'
import { useTranslation } from 'react-i18next'
import { pathOr, values } from 'ramda'

type Props = SelectProps & {
  path?: Array<number>
  isShowAll?: boolean
  isDetail?: boolean
}

export default function SessionLayerSelect({
  path = [2],
  isShowAll = false,
  isDetail = false,
  ...props
}: Props) {
  const { data } = useGetSessionTree()
  const { t } = useTranslation()

  // 資料轉換
  const transformedData = transformDataRecursively(data?.data || [])
  // 路徑轉換
  const transformedPath = transformPath(path)
  // 根據路徑提取資料
  const options = values(pathOr({}, transformedPath, transformedData))

  return (
    <Select allowClear placeholder={t('device:search sessionName')} {...props}>
      {isShowAll && (
        <Select.Option key="all" value="">
          {t('common:all')}
        </Select.Option>
      )}
      {options
        .filter((item: any) => item.available && item.status === 1)
        .map((item: any) => (
          <Select.Option
            key={item.id}
            value={isDetail ? `${item.id},${item.name}` : item.id}>
            {item.name}
          </Select.Option>
        ))}
    </Select>
  )
}

// 遞歸處理資料轉換
export const transformDataRecursively = (data: any[]): Record<string, any> => {
  return data.reduce<Record<string, any>>((acc, item) => {
    const transformedItem = { ...item }

    // 遞歸處理子屬性
    Object.keys(item).forEach(key => {
      if (Array.isArray(item[key])) {
        transformedItem[key] = transformDataRecursively(item[key])
      }
    })

    acc[item.id] = transformedItem
    return acc
  }, {})
}

// 將 path 轉換為物件路徑格式
export const transformPath = (path: number[]): Array<string | number> => {
  return path.flatMap(id => [id, 'sessions'])
}
